module.exports = __webpack_public_path__ + "img/404.96f17eaf.png";